import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** 클래스 합치기. 뒤에 온 것이 이긴다 — 화면마다 예외를 줄 수 있게. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
